.flyTableRoot > div[class='rt-ScrollAreaRoot'] {
  max-height: var(--fly-table-height);

  // Fix for max-width not being applied
  th:global(.rt-r-max-w),
  td:global(.rt-r-max-w) {
    width: 10000px;
  }
}

.flySortIcon {
  transition: transform 0.2s ease-in-out;
  visibility: hidden;

  &.asc {
    visibility: visible;
    transform: rotate(180deg);
  }

  &.desc {
    visibility: visible;
    transform: rotate(0deg);
  }
}
